import React from 'react';
import PropTypes from 'prop-types';

import {Box} from 'views/components';

import {ImageDisplay, FileDisplay} from './DisplayComponents';

import backend from 'utils/backend';

const SecureFile = (props) => {
  const [downloadedSrc, setDownloadedSrc] = React.useState(null);

  const file = props.file;
  const sx = props.sx;

  const {type, src} = file;

  React.useEffect(() => {
    setDownloadedSrc(null);
  }, [src]);

  const getDownloadedSrc = async () => {
    if (downloadedSrc) {
      return downloadedSrc;
    } else {
      const file = await backend.fileStorage.getSecureFile(src);
      const fileSrc = URL.createObjectURL(file);
      setDownloadedSrc(fileSrc);
      return fileSrc;
    }
  };

  const DisplayComponent = type.match(/image\/.*/) ? ImageDisplay : FileDisplay;

  return (
    <Box
      height={'100%'}
      sx={{
        'minWidth': 'inherit',
        'maxWidth': 'inherit',
        ...sx,
      }}
    >
      <DisplayComponent
        getDownloadedSrc={getDownloadedSrc}
      />
    </Box>
  );
};

SecureFile.propTypes = {
  file: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
  }).isRequired,
  sx: PropTypes.object,
};

export default React.memo(SecureFile);

